import { Context, Effect, Scope } from 'effect'
import type { DocumentStructure, TextRect } from '../../models'

export class MuPDFDocumentOpenError extends Error {
  readonly _tag = 'MuPDFDocumentOpenError' as const

  constructor(readonly cause: Error) {
    super(cause.message)
  }
}

export class MuPDFPageRenderError extends Error {
  readonly _tag = 'MuPDFPageRenderError' as const

  constructor(readonly cause: Error) {
    super(cause.message)
  }
}

export class MuPDFPageTextExtractionError extends Error {
  readonly _tag = 'MuPDFPageTextExtractionError' as const

  constructor(readonly cause: Error) {
    super(cause.message)
  }
}

export class MuPDFWorkerCrashedError extends Error {
  readonly _tag = 'MuPDFWorkerCrashedError' as const

  constructor(readonly cause: Error) {
    super(cause.message)
  }
}

export type MuPDFDocumentSession = {
  readonly documentStructure: DocumentStructure
  readonly renderPageAsImage: (
    pageNumber: number,
    scale: number
  ) => Effect.Effect<ImageBitmap, MuPDFPageRenderError | MuPDFWorkerCrashedError>
  readonly extractPageText: (
    pageNumber: number
  ) => Effect.Effect<TextRect[], MuPDFPageTextExtractionError | MuPDFWorkerCrashedError>
}

export type MuPDFPlatformService = {
  /**
   * Opens a scoped MuPDF document and takes ownership of `documentBytes`.
   *
   * Browser implementations transfer the buffer into their worker, so callers
   * must not retain or reuse it. Closing the surrounding Scope closes every
   * outstanding request and the underlying document runtime.
   */
  readonly openDocument: (
    documentBytes: ArrayBuffer
  ) => Effect.Effect<
    MuPDFDocumentSession,
    MuPDFDocumentOpenError | MuPDFWorkerCrashedError,
    Scope.Scope
  >
}

export class MuPDFPlatform extends Context.Service<MuPDFPlatform, MuPDFPlatformService>()(
  'MuPDFPlatform'
) {}
